const COGNITO_BASE_URL = 'https://mm-viewer.auth.eu-west-2.amazoncognito.com/';
const COGNITO_CLIENT_ID = '7hvlt2gphdrg1j2roos701kj19';
const HOST_URL = 'https://set-top-box.dev.medimusic.co';
const API_URL = 'https://catalogue.dev.medimusic.co/';
const ENABLE_SURVEYS = false;
const config = {COGNITO_BASE_URL, COGNITO_CLIENT_ID, HOST_URL, API_URL, ENABLE_SURVEYS};
export default config
